import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header/Header';
import Services from '../components/Services';


const ServicePage = () => {
    return (
        <>
            <Header />
            <Services/>
            <Footer />
        </>
    )
}

export default ServicePage;